import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
// import Gallery from "../views/Gallery.vue";
import Login from "../views/Login.vue";
import Customers from "../views/Customers.vue";
import Broucher from "../views/Broucher.vue";
import Testimonials from "../views/Testimonials.vue";
import Certificates from "../views/Certificates.vue";
import Products from "../views/Products.vue";
import { fb } from "../firebase";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    //eslint-disable-next-line
    return originalPush.call(this, location).catch((error) => {});
};
const routes = [{
        path: "/",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/Login",
        name: "Login",
        component: Login,
    },
    {
        path: "/broucher",
        name: "Broucher",
        component: Broucher,
        // meta: {
        //     requiresAuth: true,
        // },
    },
    {
        path: "/testimonials",
        name: "Testimonials",
        component: Testimonials,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/certificates",
        name: "Certificates",
        component: Certificates,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/Customers",
        name: "Customers",
        component: Customers,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/Product",
        name: "Products",
        component: Products,
        meta: {
            requiresAuth: true,
        },
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const currentUser = fb.auth().currentUser;

    if (requiresAuth && !currentUser) {
        next("/Login");
    } else if (requiresAuth && currentUser) {
        next();
    } else {
        next();
    }
});

export default router;